/**
 * Session 37 · Phase 2 · Journey Action Registry.
 *
 * Zentrale Definition aller stabilen Event-IDs mit deutschen Labels.
 * Nutzung: import { ACTIONS } from '@/lib/journey/actions'; trackAction(ACTIONS.HOME_CTA_PRIVATE)
 */

export const ACTIONS = {
  // --- Startseite ---
  HOME_CTA_PRIVATE: { id: "home_cta_private", label: "Privatkunden-CTA angeklickt" },
  HOME_CTA_BUSINESS: { id: "home_cta_business", label: "Businesskunden-CTA angeklickt" },
  HOME_MENU_CLICK: { id: "home_menu_click", label: "Menü-Link angeklickt" },

  // --- Privatkunden ---
  PRIVATE_CTA_AVAILABILITY: { id: "private_cta_availability", label: "Verfügbarkeit prüfen" },
  PRIVATE_CTA_SYSTEMS: { id: "private_cta_systems", label: "Systeme ansehen" },
  PRIVATE_SYSTEM_CARD: { id: "private_system_card", label: "System-Kachel angeklickt" },
  PRIVATE_CONTACT_LINK: { id: "private_contact_link", label: "Kontakt-Link angeklickt" },

  // --- Businesskunden ---
  BUSINESS_HERO_CTA: { id: "business_hero_cta", label: "Business Hero-CTA angeklickt" },
  BUSINESS_REQUEST_BUTTON: { id: "business_request_button", label: "Anfrage-Button angeklickt" },
  BUSINESS_SYSTEM_CARD_MAGIC_MIRROR: { id: "business_system_card_magic_mirror", label: "System: Magic Mirror angeklickt" },
  BUSINESS_SYSTEM_CARD_PREMIUM: { id: "business_system_card_premium", label: "System: Fotobox Premium angeklickt" },
  BUSINESS_CONTACT_PHONE: { id: "business_contact_phone", label: "Telefon-Link angeklickt" },
  BUSINESS_CONTACT_EMAIL: { id: "business_contact_email", label: "E-Mail-Link angeklickt" },
  BUSINESS_FORM_START: { id: "business_form_start", label: "Businessanfrage begonnen" },
  BUSINESS_FORM_FIELD: { id: "business_form_field", label: "Formularfeld gefüllt" },
  BUSINESS_FORM_SUBMIT: { id: "business_form_submit", label: "Businessanfrage abgesendet" },
  BUSINESS_FORM_VALIDATION_ERROR: { id: "business_form_validation_error", label: "Validierungsfehler im Formular" },
  BUSINESS_FORM_TECHNICAL_ERROR: { id: "business_form_technical_error", label: "Technischer Fehler im Formular" },

  // --- Booking / Wizard ---
  BOOKING_FIRST_PRODUCT_SELECT: { id: "booking_first_product_select", label: "Erste Produktauswahl" },
  BOOKING_PRODUCT_SELECTED: { id: "booking_product_selected", label: "Produkt ausgewählt" },
  BOOKING_DATE_SELECTED: { id: "booking_date_selected", label: "Datum ausgewählt" },
  BOOKING_DELIVERY_MODE_SELECTED: { id: "booking_delivery_mode_selected", label: "Selbstabholung/Lieferung ausgewählt" },
  BOOKING_ADDONS_SELECTED: { id: "booking_addons_selected", label: "Zusatzleistungen ausgewählt" },
  BOOKING_CONTACT_START: { id: "booking_contact_start", label: "Kontaktdaten begonnen" },
  BOOKING_CONTACT_COMPLETE: { id: "booking_contact_complete", label: "Kontaktdaten vollständig" },
  BOOKING_GO_TO_PAYMENT: { id: "booking_go_to_payment", label: "\u201eZur Zahlung\u201c angeklickt" },
  BOOKING_PAYMENT_METHOD_SELECTED: { id: "booking_payment_method_selected", label: "Zahlungsart ausgewählt" },
  BOOKING_SUBMITTED: { id: "booking_submitted", label: "Buchung verbindlich abgesendet" },
  BOOKING_SUCCESS: { id: "booking_success", label: "Buchung erfolgreich angelegt" },
  BOOKING_VALIDATION_ERROR: { id: "booking_validation_error", label: "Validierungsfehler bei Buchung" },
  BOOKING_TECHNICAL_ERROR: { id: "booking_technical_error", label: "Technischer Fehler bei Buchung" },

  // --- Scroll ---
  SCROLL_25: { id: "scroll_25", label: "Scrolltiefe 25 %" },
  SCROLL_50: { id: "scroll_50", label: "Scrolltiefe 50 %" },
  SCROLL_75: { id: "scroll_75", label: "Scrolltiefe 75 %" },
  SCROLL_100: { id: "scroll_100", label: "Scrolltiefe 100 %" },
};

// Lookup Table: id → label (für Admin-UI zur Anzeige)
export const ACTION_LABEL_BY_ID = Object.values(ACTIONS).reduce((acc, a) => {
  acc[a.id] = a.label;
  return acc;
}, {});

export function actionLabelById(id) {
  return ACTION_LABEL_BY_ID[id] || id;
}
